import SubHeaders from '@/components/Headers/SubHeaders'
import { useTourHandler } from '@/contexts/tour-handler'
import EyeIcons from '@/icons/EyeIcons'
import PeopleIcons from '@/icons/PeopleIcons'
import { paths } from '@/utils/path'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Steps } from 'vnetwork-ui'
import { createEmployeeTmp } from '../../services'
import CreateEmployeeTmp from './CreateEmployeeTmp'
import EmployeeConfirmation from './EmployeeConfirmation'
import { useCreateEmployeeTour } from './Tour/use-create-employee-tour'

const New = () => {
    const [currentStep, setCurrentStep] = useState(1)
    const [employeeTmpData, setEmplpoyeeTmpData] = useState<Awaited<
        ReturnType<typeof createEmployeeTmp>
    > | null>(null)

    const { t } = useTranslation()
    // Tour hook
    const { startTour } = useCreateEmployeeTour()
    const { registerHandler, unregisterHandler } = useTourHandler()

    // Register tour handler
    useEffect(() => {
        registerHandler(startTour)
        return () => unregisterHandler()
    }, [registerHandler, unregisterHandler, startTour])

    const steps = {
        1: (
            <CreateEmployeeTmp
                onSuccess={(data) => {
                    setCurrentStep(2)
                    setEmplpoyeeTmpData(data)
                }}
            />
        ),
        2: <EmployeeConfirmation employeeTmpData={employeeTmpData} />,
    }

    const StepComponent = steps?.[currentStep as keyof typeof steps]

    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: paths.employeesManage,
                        title: t('employee-manage'),
                    },
                    {
                        path: paths.employeeCreate,
                        title: t('add-employee'),
                    },
                ]}
            />
            <div className="bg-white rounded-[8px] py-2 mt-2">
                <Steps
                    steps={[
                        {
                            description: t('basic-information-desc'),
                            label: t('basic-information'),
                            icon: <PeopleIcons />,
                        },
                        {
                            description: t('account-confirmation-desc'),
                            label: t('account-confirmation'),
                            icon: <EyeIcons />,
                        },
                    ]}
                    color="primary"
                    currentStep={currentStep}
                    size="small"
                    direction="vertical"
                    onChange={() => {}}
                >
                    {StepComponent && StepComponent}
                </Steps>
            </div>
        </div>
    )
}

export default New
